import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnChanges, inject, input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { CMSFacade } from 'ish-core/facades/cms.facade';
import { ShoppingFacade } from 'ish-core/facades/shopping.facade';
import { ContentPageletView } from 'ish-core/models/content-view/content-view.model';
import { whenTruthy } from 'ish-core/utils/operators';
import { CMSComponent } from 'ish-shared/cms/models/cms-component/cms-component.model';
import { ProductsListComponent } from 'ish-shared/components/product/products-list/products-list.component';

@Component({
  selector: 'ish-cms-product-list-category',
  templateUrl: './cms-product-list-category.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, RouterModule, TranslateModule, ProductsListComponent],
})
export class CMSProductListCategoryComponent implements CMSComponent, OnChanges {
  private cmsFacade = inject(CMSFacade);
  private shoppingFacade = inject(ShoppingFacade);

  readonly pagelet = input.required<ContentPageletView>();

  productSKUs$: Observable<string[]>;

  ngOnChanges() {
    if (this.pagelet().hasParam('Category')) {
      this.productSKUs$ = this.getProductSKUs$();
    }
  }

  private getProductSKUs$(): Observable<string[]> {
    return this.shoppingFacade.categoryIdByRefId$(this.pagelet().stringParam('Category')).pipe(
      whenTruthy(),
      switchMap(categoryId =>
        this.cmsFacade.parameterProductListFilter$(
          categoryId,
          undefined,
          undefined,
          this.pagelet().numberParam('MaxNumberOfProducts')
        )
      )
    );
  }
}
